import React from "react";
import "../styles/404.css";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1 className="not-found__code">404</h1>
      <p className="not-found__message">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a href="/" className="not-found__link">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
        Back to Home
      </a>
    </div>
  );
};

export default NotFound;
